(function (cw, $, undefined) {
  $.extend(true, cw, {
    constants: {
      enableDebugging: false,
      debugToConsole: true,
      relativeTimeFormat: {
        future: "in %s",
        past: "%s ago",
        s: "seconds",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: "%dd",
        M: "1mon",
        MM: "%dmon",
        y: "1y",
        yy: "%dy",
      },
      shipleyGreen: "#7ac142",
      shipleyBlue: "#407AC3",
      ctaYellow: "#ffc82e",
      ctaBlue: "#0046ad",
      ctaOrange: "#f8ac59",
      colors: [
        "#7ac142", // Shipley green
        "#0068b3",
        "#c2c2c2",
        "#23c6c8", // Info color
        "#f8ac59", //this.ctaOrange,
        "#ED5565",
        "#5791df",
        "#c159d6", //purple-ish
        "#575059", //dark grey
        "#407AC3", //this.shipleyBlue //Shipley blue
      ],
    },
  });
})((window.cw = window.cw || {}), jQuery);
